export const getVendorMinOrder = (vendor, fallbackMin = 0) => {
  if (vendor?.min_order != null && vendor.min_order !== '') {
    return parseFloat(vendor.min_order) || 0
  }
  return parseFloat(fallbackMin) || 0
}

export const getVendorDeliveryFee = (vendor, city) => {
  if (vendor?.delivery_fee != null && vendor.delivery_fee !== '') {
    return parseFloat(vendor.delivery_fee) || 0
  }
  return city?.charge ? parseFloat(city.charge) : 0
}
